import { DynamoDBClient } from "@aws-sdk/client-dynamodb";
import {
  DynamoDBDocumentClient,
  QueryCommand,
} from "@aws-sdk/lib-dynamodb";
import { fetchAuthSession } from "aws-amplify/auth";

// env
const {
  REACT_APP_REGION,
  REACT_APP_PARTNERS_TABLENAME,
} = process.env;

const queryTable = async (awsCredentials, { nextToken = null }) => {

  const docClient = DynamoDBDocumentClient.from(
    new DynamoDBClient({
      region: REACT_APP_REGION,
      credentials: awsCredentials,
    })
  );

  // build command
  const params = {
    TableName: REACT_APP_PARTNERS_TABLENAME,
    IndexName: 'status-index',
    Limit: 15,
    KeyConditionExpression: '#status = :status',
    ProjectionExpression: '\
      #account_id, \
      #application_location, \
      #date_of_birth, \
      #individual, \
      #electrical_competency, \
      #created, \
      #modified\
    ',
    ExpressionAttributeNames: {
      '#status': 'status',
      '#account_id': 'account_id',
      '#application_location': 'application_location',
      '#date_of_birth': 'date_of_birth',
      '#individual': 'individual',
      '#electrical_competency': 'electrical_competency',
      '#created': 'created',
      '#modified': 'modified',
    },
    ExpressionAttributeValues: {
      ':status': 'REGISTRATION:PENDING_APPROVAL',
    },
  };

  if (nextToken) {
    params.ExclusiveStartKey = nextToken;
  }
  const command = new QueryCommand(params);
  const res = await docClient.send(command);
  return {
    applicants: res.Items || [],
    next_token: res.LastEvaluatedKey,
  }
}

const handler = async ({ next_token = null }, { getState, rejectWithValue }) => {
  try {
    // get credentials
    const { credentials } = await fetchAuthSession();

    const res = await queryTable(credentials, { nextToken: next_token });
    console.log('services.partners.getNewApplicant@handler', 'res', res);
    return res;

  } catch (error) {
    console.error('services.partners.getNewApplicant@handler', error);
    return rejectWithValue(error);
  }
}

const pending = (state, action) => {
  return {
    ...state,
    initialized: false,
  };
}

const fulfilled = (state, action) => {
  return {
    ...state,
    lists: action.payload.applicants,
    next_token: action.payload.next_token,
  };
}

const rejected = (state, action) => {
  return {
    ...state,
    initialized: false,
  };
}

export default {
  handler,
  pending,
  fulfilled,
  rejected
}